import React, { useContext } from 'react';
import ModalContext from '../../../context/ModalContext';
import { Button } from '@mui/material';

const ValidationErrorModal = () => {
  const modalCtx = useContext(ModalContext);
  const { title, description } = modalCtx.modal.details || {};

  const handleClose = () => {
    modalCtx.closeModal();
  };

  return (
    <div className="create-devotional-container">
      <div className="devotional-header">
        <h1>{title || "Action Required"}</h1>
      </div>
      <div className="body-container create-container">
        <p variant="body1" color="text.primary">
          Please note, you cannot mark this company as complete due to the following missing fields:
        </p>
        <ul style={{ marginTop: '0.5rem', paddingLeft: '1.5rem' }}>
          <li>Logo</li>
          <li>Colour</li>
        </ul>
      </div>
      <div className="footer-devotional">
        <Button style={{color:"#555"}}  onClick={handleClose}>Close</Button>
      </div>
    </div>
  );
};

export default ValidationErrorModal;
